import axios from "axios";
import { toast } from "react-toastify";

import { SmtpSettings, SmtpSettingsApiKey, GenericSettingsApiKey, SystemSettings } from "./SystemSettings";

const SYSTEM_SETTINGS_API_URL = `${process.env.REACT_APP_API_BASE_URL}/systemsettings`;

export const fetchSystemSettings = async () => {
  const response = await axios.get(`${SYSTEM_SETTINGS_API_URL}`);
  const systemSettings = mapApiSystemSettings(response.data);
  return systemSettings;
};

export const fetchSystemSettingByKey = async (key: SmtpSettingsApiKey | GenericSettingsApiKey) => {
  const response = await axios.get(`${SYSTEM_SETTINGS_API_URL}/${key}`);
  return { key: response.data.key, value: response.data.value };
};

export const updateSmtpSettings = async (smtpSettings: SmtpSettings) => {
  const payload = [
    { key: SmtpSettingsApiKey.Server, value: smtpSettings.server },
    { key: SmtpSettingsApiKey.Port, value: smtpSettings.port },
    { key: SmtpSettingsApiKey.From, value: smtpSettings.from },
    { key: SmtpSettingsApiKey.FromDisplayName, value: smtpSettings.fromDisplayName },
    { key: SmtpSettingsApiKey.Username, value: smtpSettings.username },
    { key: SmtpSettingsApiKey.Password, value: smtpSettings.password },
    {
      key: SmtpSettingsApiKey.SecureConnection,
      value: `${smtpSettings.secureConnection}`,
    },
  ];
  await axios.post(`${SYSTEM_SETTINGS_API_URL}/bulk`, payload);
  toast.success("Setari salvate cu succes");
};

export const updateSystemSetting = async (key: SmtpSettingsApiKey | GenericSettingsApiKey, value: string) => {
  const payload = { key, value };
  await axios.post(`${SYSTEM_SETTINGS_API_URL}`, payload);
  toast.success("Setarea a fost salvată cu succes");
};

export const clearCache = async () => {
  await axios.get(`${SYSTEM_SETTINGS_API_URL}/removeAllCacheItems`);
  toast.success("Cache-ul a fost curatat cu succes");
};

const mapApiSystemSettings = (apiSystemSettings: any): SystemSettings => {
  const systemSettings: SystemSettings = {
    smtpSettings: {
      server: "",
      port: 0,
      from: "",
      fromDisplayName: "",
      username: "",
      password: "",
      secureConnection: false,
    },
    genericSettings: {
      categoryAiSearchEnabled: false,
    },
  };

  for (const { key, value } of apiSystemSettings) {
    switch (key) {
      case SmtpSettingsApiKey.Server:
        systemSettings.smtpSettings.server = value;
        break;
      case SmtpSettingsApiKey.Port:
        systemSettings.smtpSettings.port = value;
        break;
      case SmtpSettingsApiKey.From:
        systemSettings.smtpSettings.from = value;
        break;
      case SmtpSettingsApiKey.FromDisplayName:
        systemSettings.smtpSettings.fromDisplayName = value;
        break;
      case SmtpSettingsApiKey.Username:
        systemSettings.smtpSettings.username = value;
        break;
      case SmtpSettingsApiKey.Password:
        systemSettings.smtpSettings.password = value;
        break;
      case SmtpSettingsApiKey.SecureConnection:
        systemSettings.smtpSettings.secureConnection = JSON.parse(value || "false");
        break;
      case GenericSettingsApiKey.CategoryAiSearchEnabled:
        systemSettings.genericSettings.categoryAiSearchEnabled = JSON.parse(value || "false");
    }
  }

  return systemSettings;
};
